import { connect } from 'react-redux';
import { openMatrixBlur, matrixChange } from './actions';
import OpenWidget from '../inputs/OpenWidget';
import { questionKey } from '../response/reducer';
import moment from 'moment';

const mapStateToProps = (state, ownProps) => {
  const question = state[questionKey(ownProps)];
  const attachments = state.attachmentsTmap && state.attachmentsTmap[question.name]
    ? state.attachmentsTmap[question.name][ownProps.rowName] || []
    : [];

  const tempAttachmentKey = attachments.length > 0  ? attachments[0].temp_multi_attachment_key : question.temp_response_attachment_keys[ownProps.rowIndex];


  return {
    attachments: attachments,
    className: `input-block-level ${ownProps.className || ''}`,
    isValid: question.isValid || question.fieldValids[ownProps.globalIndex],
    value:
      question &&
      question.rows[ownProps.rowIndex].values[ownProps.fieldIndex].value,
    uploaderConfig: {
      ...state.attachmentConfig,
      attachmentParams: {
        attachment: {
          surveyQuestionId: ownProps.questionId,
          tempMultiAttachmentKey: tempAttachmentKey
        },
        attachableId: tempAttachmentKey,
        attachableType: 'Survey::Response',
        tokenId: state.token && state.token.id,
      },
      tempMultiAttachmentKeyFieldName: `questions[images][${question.name}-${
        ownProps.rowName
      }][]`,
    },
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onChange: e => {
    // date time widgets pass a date object, everything else passes an event
    const value =
      moment.isMoment(e) || moment.isDate(e) || typeof e === 'string'
        ? e
        : e.target.value;
    dispatch(
      matrixChange(
        value,
        ownProps.rowIndex,
        ownProps.fieldIndex,
        ownProps.questionId
      )
    );
  },
  onBlur: () =>
    dispatch(
      openMatrixBlur(
        ownProps.rowIndex,
        ownProps.fieldIndex,
        ownProps.questionId
      )
    ),
});

const MatrixInput = connect(mapStateToProps, mapDispatchToProps)(OpenWidget);

export default MatrixInput;
